import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = {
  schedules: "/reports/schedules",
  averageTicket: "/reports/average-ticket",
  salesReport: "/reports/sales-report",
  totalSpentByClient: "/reports/clients-total",
  clientSpendingByType: "/reports/clients-simples",
  statisticalReport: "/reports/statistical-report",
  graphics: "/reports/graphics",
};

export const fetchReportSchedules = createAsyncThunk(
  "reportSchedules/fetchReportSchedules",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.schedules, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const fetchAverageTicket = createAsyncThunk(
  "averageTicket/fetchAverageTicket",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.averageTicket, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const fetchSalesReport = createAsyncThunk(
  "salesReport/fetchSalesReport",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.salesReport, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const fetchTotalSpentByClient = createAsyncThunk(
  "totalSpentByClient/fetchTotalSpentByClient",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.totalSpentByClient, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const fetchClientSpendingByType = createAsyncThunk(
  "statisticalRepor/fetchClientSpendingByType",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.clientSpendingByType, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const fetchStatisticalReport = createAsyncThunk(
  "statisticalReport/fetchStatisticalReport",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.statisticalReport, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);

export const fetchGrafics = createAsyncThunk(
  "grafics/fetchGrafics",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.graphics, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      } else {
        return thunkAPI.rejectWithValue({
          error: "An unknown error occurred",
        });
      }
    }
  },
);
